module.exports = __webpack_public_path__ + "img/baoxiaomi-opk-exercise.450313b9.png";